// Autocomplétion d'adresse pour la facture nominative (écran 1m).
//
// Géoplateforme de l'IGN (base adresse nationale) : gratuite, sans clé, ouverte
// aux appels du navigateur. Elle ne couvre que la France, comme la table des
// codes postaux que QoREST contrôle à l'enregistrement de la facture.
const GEOCODER_URL = "https://data.geopf.fr/geocodage/search";
const ADDRESS_TYPES = ["housenumber", "street", "locality"];

export const MIN_ADDRESS_QUERY_LENGTH = 3;

export const searchAddresses = async (query, signal) => {
  const params = new URLSearchParams({ q: query, limit: "5", autocomplete: "1" });
  const response = await fetch(`${GEOCODER_URL}?${params}`, { signal });
  if (!response.ok) return [];

  const data = await response.json();
  return (data.features || [])
    .map((feature) => feature.properties || {})
    .filter((p) => ADDRESS_TYPES.includes(p.type) && p.postcode && p.city)
    .map((p) => ({
      id: p.id,
      label: p.label,
      street: p.name,
      postalCode: p.postcode,
      city: p.city,
    }));
};
